// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historico-andaimes-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    color: #333;
}

.ha-content-wrapper {
    max-width: 800px;
    margin: 0 auto;
    width: 100%;
}

.ha-header {
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #0056b3;
}

.ha-header-top {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 4px;
}

.ha-back-btn {
    background: none;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 0.85rem;
    cursor: pointer;
    color: #555;
}

.ha-header h2 {
    margin: 0;
    color: #1a1a1a;
    font-size: 1.3rem;
}

.ha-header p {
    margin: 0;
    color: #666;
    font-size: 0.85rem;
}

.ha-search {
    margin-bottom: 18px;
}

.ha-search input {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 0.95rem;
    box-sizing: border-box;
}

.ha-search input:focus {
    outline: none;
    border-color: #0056b3;
    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);
}

.ha-error {
    background-color: #f8d7da;
    color: #721c24;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 15px;
    font-size: 0.9rem;
}

.ha-loading {
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 1rem;
}

.ha-empty {
    text-align: center;
    padding: 40px 20px;
    color: #888;
}

.ha-empty p {
    margin-bottom: 15px;
}

.ha-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.ha-card {
    background: #fff;
    border: 1px solid #e1e4e8;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ha-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e1e4e8;
}

.ha-num {
    font-weight: 700;
    color: #0056b3;
    font-size: 0.95rem;
}

.ha-resultado {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 12px;
}

.ha-resultado.apto {
    background-color: #d4edda;
    color: #155724;
}

.ha-resultado.nao-apto {
    background-color: #f8d7da;
    color: #721c24;
}

.ha-card-body {
    padding: 10px 14px;
}

.ha-info-row {
    display: flex;
    gap: 6px;
    font-size: 0.85rem;
    padding: 2px 0;
    color: #444;
}

.ha-label {
    font-weight: 600;
    min-width: 80px;
    color: #555;
}

.ha-card-actions {
    display: flex;
    gap: 8px;
    padding: 10px 14px;
    border-top: 1px solid #f0f0f0;
}

.ha-btn {
    flex: 1 1;
    padding: 8px 10px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    text-align: center;
    transition: opacity 0.2s;
}

.ha-btn:hover {
    opacity: 0.85;
}

.ha-btn-pdf {
    background-color: #dc3545;
    color: white;
}

.ha-btn-share {
    background-color: #25D366;
    color: white;
}

.ha-footer-action {
    margin-top: 20px;
    text-align: center;
}

.ha-new-btn {
    background-color: #0056b3;
    color: white;
    border: none;
    padding: 12px 25px;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
    width: 100%;
}

.ha-new-btn:hover {
    background-color: #004494;
}`, "",{"version":3,"sources":["webpack://./src/pages/HistoricoAndaimes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,yGAAyG;IACzG,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".historico-andaimes-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n    color: #333;\r\n}\r\n\r\n.ha-content-wrapper {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n}\r\n\r\n.ha-header {\r\n    margin-bottom: 20px;\r\n    padding-bottom: 12px;\r\n    border-bottom: 2px solid #0056b3;\r\n}\r\n\r\n.ha-header-top {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.ha-back-btn {\r\n    background: none;\r\n    border: 1px solid #ccc;\r\n    border-radius: 6px;\r\n    padding: 6px 12px;\r\n    font-size: 0.85rem;\r\n    cursor: pointer;\r\n    color: #555;\r\n}\r\n\r\n.ha-header h2 {\r\n    margin: 0;\r\n    color: #1a1a1a;\r\n    font-size: 1.3rem;\r\n}\r\n\r\n.ha-header p {\r\n    margin: 0;\r\n    color: #666;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.ha-search {\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.ha-search input {\r\n    width: 100%;\r\n    padding: 10px 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    font-size: 0.95rem;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.ha-search input:focus {\r\n    outline: none;\r\n    border-color: #0056b3;\r\n    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);\r\n}\r\n\r\n.ha-error {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    margin-bottom: 15px;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.ha-loading {\r\n    text-align: center;\r\n    padding: 40px;\r\n    color: #666;\r\n    font-size: 1rem;\r\n}\r\n\r\n.ha-empty {\r\n    text-align: center;\r\n    padding: 40px 20px;\r\n    color: #888;\r\n}\r\n\r\n.ha-empty p {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.ha-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.ha-card {\r\n    background: #fff;\r\n    border: 1px solid #e1e4e8;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ha-card-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 14px;\r\n    background-color: #f8f9fa;\r\n    border-bottom: 1px solid #e1e4e8;\r\n}\r\n\r\n.ha-num {\r\n    font-weight: 700;\r\n    color: #0056b3;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.ha-resultado {\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    padding: 3px 8px;\r\n    border-radius: 12px;\r\n}\r\n\r\n.ha-resultado.apto {\r\n    background-color: #d4edda;\r\n    color: #155724;\r\n}\r\n\r\n.ha-resultado.nao-apto {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n}\r\n\r\n.ha-card-body {\r\n    padding: 10px 14px;\r\n}\r\n\r\n.ha-info-row {\r\n    display: flex;\r\n    gap: 6px;\r\n    font-size: 0.85rem;\r\n    padding: 2px 0;\r\n    color: #444;\r\n}\r\n\r\n.ha-label {\r\n    font-weight: 600;\r\n    min-width: 80px;\r\n    color: #555;\r\n}\r\n\r\n.ha-card-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    padding: 10px 14px;\r\n    border-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.ha-btn {\r\n    flex: 1;\r\n    padding: 8px 10px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    font-size: 0.85rem;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    transition: opacity 0.2s;\r\n}\r\n\r\n.ha-btn:hover {\r\n    opacity: 0.85;\r\n}\r\n\r\n.ha-btn-pdf {\r\n    background-color: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.ha-btn-share {\r\n    background-color: #25D366;\r\n    color: white;\r\n}\r\n\r\n.ha-footer-action {\r\n    margin-top: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.ha-new-btn {\r\n    background-color: #0056b3;\r\n    color: white;\r\n    border: none;\r\n    padding: 12px 25px;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    width: 100%;\r\n}\r\n\r\n.ha-new-btn:hover {\r\n    background-color: #004494;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
